module.exports = __webpack_public_path__ + "img/painreform.5191c63c.png";